import { useContext } from "react";
import { ContextMenuContext } from "@/contexts/ContextMenuContext";

export function useContextMenu() {
  const ctx = useContext(ContextMenuContext);
  if (!ctx) throw new Error("useContextMenu outside ContextMenuProvider");
  return ctx;
}
